(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["valvetronic-videos"]) return;
  try {
    
if (!customElements.get('product-video-list')) {
  customElements.define('product-video-list', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const toggle = this.querySelector('.valvetronic-videos__toggle');
      const more = this.querySelector('.valvetronic-videos__more');
      if (toggle && more) {
        more.hidden = true;
        toggle.addEventListener('click', () => {
          more.hidden = !more.hidden;
          toggle.setAttribute('aria-expanded', String(!more.hidden));
          if (more.hidden) {
            more.querySelectorAll('iframe').forEach(frame => frame.remove());
            more.querySelectorAll('.valvetronic-videos__poster').forEach(poster => poster.hidden = false);
          }
        });
      }
      this.querySelectorAll('.valvetronic-videos__poster').forEach(poster => {
        poster.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          const frame = poster.nextElementSibling.content.firstElementChild.cloneNode(true);
          poster.parentElement.append(frame);
          poster.hidden = true;
          frame.focus();
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
